import React from 'react';
import { ListItemText, MenuItem } from '@mui/material';

const CustomMenuItem = ({ classes, onClick, children, ...rest }) => (
    <MenuItem classes={{ root: classes.menuItem }} onClick={onClick} {...rest}>
        <ListItemText disableTypography classes={{ root: classes.itemText }}>
            {children}
        </ListItemText>
    </MenuItem>
);

CustomMenuItem.propTypes = { ...MenuItem.propTypes };

export default CustomMenuItem;
